import { render, staticRenderFns } from "./seminarInfo.vue?vue&type=template&id=6d3a76d6&"
import script from "./seminarInfo.vue?vue&type=script&lang=js&"
export * from "./seminarInfo.vue?vue&type=script&lang=js&"
import style0 from "./seminarInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports